import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import PromoBanners from '../PromoBanners';
import Header from '../Header';
import Footer from '../Footer';
import FlashMessages from '../FlashMessages';
import CountryPrompt from '../CountryPrompt';
import CookieConsent from '../CookieConsent';
import SiteLoader from '../SiteLoader';
import './AppPage.scss';

const AppPage = props => (
  <div
    className={cx('app-wrapper', {
      'app-nav-open': props.isNavOpen,
      'app-overlay-active': props.overlayActive,
      'app-wrapper--save-for-later-open': props.isSaveForLaterOpen,
    })}
    style={{
      top: props.overlayActive ? `-${props.currentScrollPos}px` : null,
    }}>
    <CookieConsent />
    <CountryPrompt disabled />
    <PromoBanners location={props.location} />
    <Header />
    <FlashMessages />
    {props.children}
    <Footer />
    <SiteLoader />
    <div id="modal-container" />
  </div>
);

AppPage.propTypes = {
  overlayActive: PropTypes.bool.isRequired,
  currentScrollPos: PropTypes.number.isRequired,
  isNavOpen: PropTypes.bool.isRequired,
  children: PropTypes.node,
  location: PropTypes.object,
  isSaveForLaterOpen: PropTypes.bool,
};

export default AppPage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/AppPage/AppPage.js